import { connectHook } from 'app/common/components/connect-hook';
import { Locales } from './locales';
import { useLocales } from './locales-hook';

export default connectHook(Locales, useLocales);
